import React from 'react';

export default function ExitFullscreenIcon({
  width = 32,
  height = 32,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_10068_12114)">
        <path
          d="M9.05528 12.2332C6.54573 12.5186 3.59832 12.0695 1.04274 12.2475C-0.347581 11.9733 -0.347581 10.0849 1.04274 9.81075C3.44384 9.60001 6.26644 10.0685 8.61741 9.80461C9.30285 9.72789 9.71924 9.29619 9.80415 8.61795L9.82256 0.978295C10.1581 -0.360793 11.9843 -0.31169 12.2482 1.04274C12.0835 3.59407 12.4968 6.47889 12.2462 8.99031C12.0845 10.6097 10.6727 12.049 9.0563 12.2332H9.05528Z"
          fill="currentColor"
        />
        <path
          d="M31.0127 12.2361C28.4449 12.0909 25.5271 12.498 22.9992 12.2453C21.2733 12.0724 19.8656 10.5646 19.7326 8.85004C19.5392 6.36214 19.883 3.6277 19.7346 1.1132C19.9229 -0.289311 21.8186 -0.399794 22.1674 0.978168L22.1859 8.61782C22.2718 9.29606 22.6871 9.72776 23.3726 9.80448C25.6796 10.0643 28.4592 9.59375 30.804 9.80141C32.2875 9.93236 32.4143 11.8719 31.0127 12.2361Z"
          fill="currentColor"
        />
        <path
          d="M11.283 31.9802C10.5873 32.0928 9.98679 31.7071 9.82617 31.0227L9.80776 23.3831C9.73103 22.6977 9.2993 22.2813 8.62102 22.1964L0.920516 22.1626C-0.440141 21.7493 -0.232462 19.8456 1.18958 19.7433C3.68889 19.911 6.45931 19.5284 8.92589 19.7474C10.6405 19.8998 12.1045 21.3637 12.2569 23.0782C12.4759 25.5446 12.0933 28.3149 12.261 30.814C12.258 31.3552 11.816 31.8933 11.282 31.9792L11.283 31.9802Z"
          fill="currentColor"
        />
        <path
          d="M21.2204 31.9802C20.4664 32.1029 19.8393 31.6416 19.7452 30.8887C19.9099 28.366 19.5252 25.5681 19.7462 23.0792C19.8987 21.3647 21.3626 19.9008 23.0773 19.7483C25.5438 19.5294 28.3143 19.912 30.8136 19.7442C32.2366 19.8465 32.4433 21.7503 31.0826 22.1636L23.3821 22.1974C22.6507 22.2956 22.2578 22.7293 22.1923 23.4577C21.9785 25.8443 22.3642 28.5389 22.1882 30.9582C22.1228 31.4431 21.7002 31.9024 21.2194 31.9802H21.2204Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10068_12114">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
